export enum DistanceUnitEnum {
  METRIC = 'metric',
}
